import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";

export interface initialStateReportProps {
    report: ReportProps[],
    dataPayment: ReportProps[],
    fetching: FetchingTypes
}

const initialState: initialStateReportProps = {
    report: [],
    dataPayment:[],
    fetching: "unknown"
}

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        getReportRequest: (state) => {
            state.fetching = "loading";
        },
        getReportSuccess: (state, action) => {
            state.fetching = "success";
            state.report = action.payload
        },
        getReportFailure: (state) => {
            state.fetching = "failure";
        },
        getDataPaymentRequest: (state) => {
            state.fetching = "loading";
        },
        getDataPaymentSuccess: (state, action) => {
            state.fetching = "success";
            state.dataPayment = action.payload
        },
        getDataPaymentFailure: (state) => {
            state.fetching = "failure";
        },
        getPaymentProcessRequest: (state) => {
            state.fetching = "loading";
        },
        getPaymentProcessSuccess: (state, action) => {
            state.fetching = "success";
            state.dataPayment = action.payload
        },
        getPaymentProcessFailure: (state) => {
            state.fetching = "failure";
        },
        cleanReport: (state) => {
            state.fetching = initialState.fetching;
            state.report = initialState.report;
            state.dataPayment = initialState.dataPayment;
        }
    }
});

export const {
    getReportRequest,
    getReportSuccess,
    getReportFailure,
    getDataPaymentRequest,
    getDataPaymentSuccess,
    getDataPaymentFailure,
    getPaymentProcessRequest,
    getPaymentProcessSuccess,
    getPaymentProcessFailure,
    cleanReport
} = reportSlice.actions;

export default reportSlice.reducer;